const timezone = [
  { label: "West Africa Time (Africa/Lagos)", value: "Africa/Lagos" },
  {
    label: "South Africa Standard Time (Africa/Johannesburg)",
    value: "Africa/Johannesburg",
  },
  { label: "East Africa Time (Africa/Nairobi)", value: "Africa/Nairobi" },
  { label: "Greenwich Mean Time (Africa/Abidjan)", value: "Africa/Abidjan" },
  { label: "Central Africa Time (Africa/Cairo)", value: "Africa/Cairo" },
  {
    label: "Western European Time (Africa/Casablanca)",
    value: "Africa/Casablanca",
  },
  { label: "Eastern Time (America/New_York)", value: "America/New_York" },
  { label: "Central Time (America/Chicago)", value: "America/Chicago" },
  { label: "Mountain Time (America/Denver)", value: "America/Denver" },
  { label: "Pacific Time (America/Los_Angeles)", value: "America/Los_Angeles" },
  { label: "Arizona Time (America/Phoenix)", value: "America/Phoenix" },
  { label: "Canada Eastern Time (America/Toronto)", value: "America/Toronto" },
  {
    label: "Canada Pacific Time (America/Vancouver)",
    value: "America/Vancouver",
  },
  {
    label: "Mexico City Time (America/Mexico_City)",
    value: "America/Mexico_City",
  },
  { label: "Brasília Time (America/Sao_Paulo)", value: "America/Sao_Paulo" },
  {
    label: "Argentina Time (America/Argentina/Buenos_Aires)",
    value: "America/Argentina/Buenos_Aires",
  },
  { label: "Colombia Time (America/Bogota)", value: "America/Bogota" },
  { label: "India Standard Time (Asia/Kolkata)", value: "Asia/Kolkata" },
  { label: "Gulf Standard Time (Asia/Dubai)", value: "Asia/Dubai" },
  { label: "Japan Standard Time (Asia/Tokyo)", value: "Asia/Tokyo" },
  { label: "Korea Standard Time (Asia/Seoul)", value: "Asia/Seoul" },
  { label: "Indochina Time (Asia/Bangkok)", value: "Asia/Bangkok" },
  { label: "Hong Kong Time (Asia/Hong_Kong)", value: "Asia/Hong_Kong" },
  {
    label: "Singapore Standard Time (Asia/Singapore)",
    value: "Asia/Singapore",
  },
  { label: "Malaysia Time (Asia/Kuala_Lumpur)", value: "Asia/Kuala_Lumpur" },
  { label: "China Standard Time (Asia/Shanghai)", value: "Asia/Shanghai" },
  { label: "Western Indonesia Time (Asia/Jakarta)", value: "Asia/Jakarta" },
  { label: "Philippine Time (Asia/Manila)", value: "Asia/Manila" },
  { label: "Nepal Time (Asia/Kathmandu)", value: "Asia/Kathmandu" },
  { label: "Arabian Standard Time (Asia/Riyadh)", value: "Asia/Riyadh" },
  {
    label: "Australian Eastern Time (Australia/Sydney)",
    value: "Australia/Sydney",
  },
  {
    label: "Australian Eastern Time (Australia/Melbourne)",
    value: "Australia/Melbourne",
  },
  {
    label: "Australian Eastern Standard Time (Australia/Brisbane)",
    value: "Australia/Brisbane",
  },
  {
    label: "Australian Western Time (Australia/Perth)",
    value: "Australia/Perth",
  },
  {
    label: "Australian Central Time (Australia/Adelaide)",
    value: "Australia/Adelaide",
  },
  { label: "British Time (Europe/London)", value: "Europe/London" },
  { label: "Central European Time (Europe/Berlin)", value: "Europe/Berlin" },
  { label: "Central European Time (Europe/Paris)", value: "Europe/Paris" },
  { label: "Central European Time (Europe/Madrid)", value: "Europe/Madrid" },
  { label: "Central European Time (Europe/Rome)", value: "Europe/Rome" },
  { label: "Moscow Standard Time (Europe/Moscow)", value: "Europe/Moscow" },
  { label: "Turkey Time (Europe/Istanbul)", value: "Europe/Istanbul" },
  { label: "Eastern European Time (Europe/Athens)", value: "Europe/Athens" },
  {
    label: "Central European Time (Europe/Amsterdam)",
    value: "Europe/Amsterdam",
  },
  { label: "Central European Time (Europe/Zurich)", value: "Europe/Zurich" },
  { label: "New Zealand Time (Pacific/Auckland)", value: "Pacific/Auckland" },
  { label: "Fiji Time (Pacific/Fiji)", value: "Pacific/Fiji" },
  { label: "Guam Time (Pacific/Guam)", value: "Pacific/Guam" },
  {
    label: "Hawaii Standard Time (Pacific/Honolulu)",
    value: "Pacific/Honolulu",
  },
  {
    label: "Papua New Guinea Time (Pacific/Port_Moresby)",
    value: "Pacific/Port_Moresby",
  },
  { label: "Tonga Time (Pacific/Tongatapu)", value: "Pacific/Tongatapu" },
  { label: "Coordinated Universal Time (UTC)", value: "UTC" },
];
export default timezone;
